import './App.scss';
import { BrowserRouter } from 'react-router-dom';
import Router from './common/Router';
import UserContext from './UserContext';
import { useState } from 'react';
import Header from './common/Header';
import Cookies from 'js-cookie'
function App() {
  const [userData, setUserData] = useState({});
// const [userToken, setuserToken] = useState(Cookies.get("userToken"))
  return (
   <BrowserRouter>
   <UserContext.Provider value={[userData, setUserData]}>
    {/* <Header/> */}
   <Router/>
   </UserContext.Provider>
   </BrowserRouter>
  );
}

export default App;
